import React, { PureComponent } from 'react';
import { Card, CardContent, Button, Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import { WithStyles, withStyles } from '@material-ui/core';
import { courseListingStyles } from '../../../styles';

interface CourseListingProps extends WithStyles<typeof courseListingStyles> {
    course: any,
    currentPage: number,
    handleComponentSwitching?:Function,
    handleOnSelect?: Function
    classes: any;
    
}
class CourseListing extends PureComponent<CourseListingProps>{
    constructor(props: CourseListingProps) {
        super(props)
    }
    phaseData = (phaseData: any) => {
        const { name = '', coursePlanId = null , startDate = '', expiryDate = '' } = phaseData;
        let phaseCountData = 0;
        let phaseTestCountData = 0;
        let startDateData = '2021-05-11T10:48:34.426Z';
        let expiryDateData = '2022-05-13T10:48:34.426Z';
        if (startDate && expiryDate) {
            startDateData = startDate;
            expiryDateData = expiryDate;
        }
        const convertedStartDate = moment(startDateData);
        const convertedEndDate = moment(expiryDateData);
        const differenceOfDates = convertedEndDate.diff(convertedStartDate, 'days');
        if (coursePlanId) {
            const { phaseCount, phaseTestCount } = coursePlanId;
            phaseCountData = phaseCount;
            phaseTestCountData = phaseTestCount;
        }
        const {classes} = this.props
        return (
          <Grid container direction="column">
            <Grid item>
              <Grid className={classes.cardTitle}>{name}</Grid>
            </Grid>

            <Grid item>
              <ul className={classes.cardItems}>
                <li>{`Total Phase ${phaseCountData}`}</li>
                <li>{`Phase Test ${phaseTestCountData}`}</li>
                <li>{`Time ${differenceOfDates} days`}</li>
              </ul>
            </Grid>
          </Grid>
        );

    }
    renderCourseListing = () => {
        const { course = [],handleComponentSwitching, handleOnSelect } = this.props;
        const {classes} = this.props
        return (
          <>
            {course &&
              Boolean(course.length) &&
              course.map((courseData: any) => (
                <Card className={classes.courseCard}>
                  <CardContent className={classes.courseCardContent}>
                    <Grid container justify="space-between" alignItems="center">
                      <Grid item xs={8}>{this.phaseData(courseData)}</Grid>

                      <Grid item xs="auto">
                      <Button
                        onClick={() => {
                          handleComponentSwitching &&
                            handleComponentSwitching(
                              "View",
                              courseData.coursePlanId &&
                                courseData.coursePlanId._id
                            );
                        }}
                      >
                        view
                      </Button>
                      <Button
                        onClick={() =>
                          handleOnSelect && handleOnSelect(courseData)
                        }
                      >
                        select
                      </Button>
                    </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))}
          </>
        );
    }
    render = () => {
        return (
            this.renderCourseListing()
        )
    }

}

// export default CourseListing;

// @ts-ignore
export default withStyles(courseListingStyles)(CourseListing);